// admin 

const saveToken = (token) => {
    localStorage.setItem('token', token);
}

const logout = () => {
    localStorage.removeItem('token')
}

const isLogged = () => {
    const token = localStorage.getItem('token');
    return token
}
const getToken = () => {
    const token = localStorage.getItem('token');
    return token;
}

// company 

const saveTokenCompany = (tokenCompany) => {
    localStorage.setItem('tokenCompany', tokenCompany);
}

const logoutCompany = () => {
    localStorage.removeItem('tokenCompany')
}

const isLoggedCompany = () => {
    const token = localStorage.getItem('tokenCompany');
    return token
}

const getTokenCompany = () => {
    const token = localStorage.getItem('tokenCompany');
    return token;
}

// client 

const saveTokenClient = (tokenClient) => {
    localStorage.setItem('tokenClient', tokenClient);
}

const logoutClient = () => {
    localStorage.removeItem('tokenClient')
}

const isLoggedClient = () => {
    const token = localStorage.getItem('tokenClient');
    return token
}

const getTokenClient = () => {
    const token = localStorage.getItem('tokenClient');
    return token;
}

export const account_service = {
    // admin
    saveToken,
    logout,
    isLogged,
    getToken,

    // company
    getTokenCompany,
    logoutCompany,
    isLoggedCompany,
    saveTokenCompany,

    // client
    getTokenClient,
    logoutClient,
    isLoggedClient,
    saveTokenClient
}